import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CoaParameter, ProductCoasParameter, ProductParameterResponse } from 'src/app/models/coa-parameter';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { CoasParameterService } from 'src/app/services/coas-parameter.service';
import { CompanyService } from 'src/app/services/company.service';
import { ProductCpService } from 'src/app/services/product-cp.service';
import { ProductService } from 'src/app/services/product.service';
import { VendorService } from 'src/app/services/vendor.service';

interface ProductCoasTemplateResponse {
  id: number;
  name: string;
  productId: number;
  product: ProductResponse;
  companyId: number;
  parameters: any[];
}

@Component({
  selector: 'app-parameters-products-list',
  templateUrl: './parameters-products-list.component.html',
  styleUrls: ['./parameters-products-list.component.scss']
})
export class ParametersProductsListComponent {
  parameterData = {
    parameter: null,
    method: null,
    units: null
  }

  parameters: ProductParameterResponse[] = [];
  creating = false;
  loading = false;
  loadingData = false;
  editing: number = null;
  editItem: CoaParameter = null;
  editItemTemp: CoaParameter = null;
  filterWord: string = "";
  filterParameters: ProductParameterResponse[] = [];

  products: ProductResponse[] = [];
  providers: VendorResponse[] = [];
  coasParameter: CoaParameter[] = [];
  inputs = {
    provider: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        measurement: null
      }
    },
    parameter: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
      }
    },
    template: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  }
  filterProducts: ProductResponse[] = [];
  filterProviders: VendorResponse[] = [];
  filterCoasParameter: CoaParameter[] = [];
  currentProduct: ProductResponse;
  currentProvider: VendorResponse;
  timeout = null;
  showParams: { [key: string]: boolean } = {};
  productsCpVendor = null;
  checkListOwnProducts = false;

  templates: ProductCoasTemplateResponse[] = [];
  filterTemplates: ProductCoasTemplateResponse[] = [];
  currentTemplate: ProductCoasTemplateResponse = null;
  usingTemplate = false;
  loadingTemplate = false;

  constructor(
    private vendorService: VendorService,
    private productService: ProductService,
    private coasParameterService: CoasParameterService,
    private toastrService: ToastrService,
    private productCpService: ProductCpService,
    private companyService: CompanyService,
  ) { }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getProviders("");
    this.getCheckListOwnProducts();
    this.getParameters("");
    this.getTemplates("");
  }

  getCheckListOwnProducts(){
    this.companyService.checkCompanyConfigListOwnProducts().subscribe({
      next: (response: ResponseObject) => {
        this.checkListOwnProducts = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    });
  }

  getProviders(clue) {
    this.vendorService.getProvidesByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.providers = response.data;
        this.filterProviders = this.providers;
        if (this.filterProviders.length == 0) {
          this.changeInput(this.inputs.provider, null, false, null, 'fa-xmark', null);
        } else if (this.filterProviders.length == 1) {
          this.changeInput(this.inputs.provider, this.filterProviders[0].name, true, null, 'fa-circle-check', this.filterProviders[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    });
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        let allProducts = response.data;

        if (this.checkListOwnProducts && this.productsCpVendor && this.productsCpVendor.length > 0) {
          const allowedProductIds = this.productsCpVendor.map(p => p.productId);
          this.products = allProducts.filter(prod => allowedProductIds.includes(prod.id));
        } else {
          this.products = allProducts;
        }

        this.filterProducts = [...this.products];

        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        this.toastrService.error(error.error.message);
      }
    });
  }



  getProductsCpByVendor(providerId: number) {
    this.productCpService.getProducsCPByVendorId(providerId).subscribe({
      next: (response: ResponseObject) => {
        this.productsCpVendor = response.data || [];

        // 🔹 Si está activado el filtro de propios, traer y filtrar productos
        if (this.checkListOwnProducts && this.productsCpVendor.length > 0) {
          this.productService.getProducts('').subscribe({
            next: (resp: ResponseObject) => {
              const allProducts: ProductResponse[] = resp.data;
              const allowedIds = this.productsCpVendor.map(p => p.productId);
              this.products = allProducts.filter(prod => allowedIds.includes(prod.id));
              this.filterProducts = [...this.products];

              this.inputs.product.value = '';
              this.inputs.product.class = 'fa-list';
              this.inputs.product.verified = false;
            },
            error: (err: HttpErrorResponse) => {
              this.toastrService.error('Error al cargar productos del proveedor');
            }
          });
        } else {
          // 🟢 Si NO hay restricción, traer todos los productos directamente
          this.productService.getProducts('').subscribe({
            next: (resp: ResponseObject) => {
              this.products = resp.data;
              this.filterProducts = [...this.products];
              this.inputs.product.value = '';
              this.inputs.product.class = 'fa-list';
              this.inputs.product.verified = false;
            },
            error: (err: HttpErrorResponse) => {
              this.toastrService.error('Error al cargar productos');
            }
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
        this.productsCpVendor = [];
        this.filterProducts = [];
      }
    });
  }

  getParameters(clue) {
    this.coasParameterService.getCoasParameters().subscribe({
      next: (response: ResponseObject) => {
        this.coasParameter = response.data

        this.filterCoasParameter = this.coasParameter;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.parameter, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.parameter, this.filterCoasParameter[0].parameter, true, null, 'fa-circle-check', this.filterCoasParameter[0]);
        } else {
          this.changeInput(this.inputs.parameter, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.parameter, null, false, null, 'fa-xmark', null);
        this.toastrService.error(error.error.message);
      }
    });
  }

  getProductParameters(filterWord: any){
    this.loadingData = true;
    this.coasParameterService.getAssigProviderProductParameters(filterWord).subscribe({
      next: (response: ResponseObject) => {
        this.parameters = response.data;
        this.filterParameters = this.parameters;
        this.filter();
        this.loadingData = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
        this.loadingData = false;
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeProvider(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.provider.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProviders(inputValue);
    }, 500);
  }

  checkProvider(vendor: VendorResponse) {
    this.inputs.provider.class = "fa-circle-check";
    this.inputs.provider.verified = true;
    this.inputs.provider.data = vendor;
    this.inputs.provider.value = vendor.name;
    this.currentProvider = vendor;

    this.getProductsCpByVendor(vendor.id);
  }


  writeProduct(input) {
    if (!this.currentProvider) {
      this.toastrService.warning('Primero selecciona un proveedor antes de buscar productos');
      return;
    }

    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }


  checkProduct(product: ProductResponse) {
    this.inputs.product.class = "fa-circle-check";
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.value = product.name;
    this.currentProduct = product;
  }

  writeParameter(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.parameter.class = "typing";
    this.timeout = setTimeout(() => {
      this.getParameters(inputValue);
    }, 500);
  }

  checkParameter(parameter: CoaParameter) {
    this.inputs.parameter.class = "fa-circle-check";
    this.inputs.parameter.verified = true;
    this.inputs.parameter.data = parameter;
    this.inputs.parameter.value = parameter.parameter;
  }

  createProductParameter(){
    if (this.currentProvider==null || this.currentProduct==null || !this.inputs.parameter.data.id) {
      return ;
    }

    this.loading = true;
    this.coasParameterService.getIsExisteAssign(this.inputs.parameter.data.id, this.currentProvider.id, this.currentProduct.id).subscribe({
      next: (response: ResponseObject) => {
        if (response.data) {
          this.toastrService.error("Ya existe esta asignacion", "Error");
          this.loading = false;
        } else {
          this.addAssigment();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al crear la asingacion", "Error");
        this.loading = false;
      }
    });
  }

  addAssigment() {
    let data = {
      providerId: this.currentProvider.id,
      productId: this.currentProduct.id,
      coasParameterId: this.inputs.parameter.data.id
    }
    this.coasParameterService.createProductParameter(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Asignacion Creada Correctamente", "Exito");
        this.getProductParameters(this.filterWord);
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al crear la asingacion", "Error");
        this.loading = false;
      }
    });
  }

  get verifyTemplateForm() {
    return this.currentProvider != null && this.currentTemplate != null;
  }

  filter() {
    // this.filterParameters = this.parameters.filter((pr) => {
    //   return (pr.productData.name).toLowerCase().includes(this.filterWord.toLowerCase()) ||
    //   (pr.productData.code.toLowerCase().includes(this.filterWord.toLowerCase())) ;
    // })

    // this.filterParameters = this.filterParameters.sort((a, b) =>
    //   a.productData.name.localeCompare(b.productData.name)
    // );
  }

  showParamsProduct(item: ProductParameterResponse) {
    const key = `${item.productData.id}-${item.providerData.id}`;
    if (!this.showParams[key])
      this.showParams[key] = true;
    else
      this.showParams[key] = !this.showParams[key];
  }

  deleteProductParameter(item: ProductCoasParameter) {
    this.coasParameterService.deleteParameter(item.coasParameterId).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Se eliminio la asignacion correctamente", "Exito");
        this.getProductParameters(this.filterWord);
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Erro al eliminar la asignacion", "Error");
      }
    });
  }

  searching() {
    this.getProductParameters(this.filterWord);
  }

  getTemplates(clue: string) {
    this.coasParameterService.getTemplates(clue).subscribe({
      next: (response: ResponseObject) => {
        this.templates = response.data || [];
        this.filterTemplates = this.templates;

        if (this.filterTemplates.length == 0) {
          this.changeInput(this.inputs.template, null, false, null, 'fa-xmark', null);
        } else {
          this.changeInput(this.inputs.template, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error?.message || 'Error al cargar plantillas');
      }
    });
  }

  writeTemplate(input) {
    const inputValue = input.target.value;

    clearTimeout(this.timeout);
    this.inputs.template.class = "typing";

    this.timeout = setTimeout(() => {
      this.getTemplates(inputValue);
    }, 500);
  }

  checkTemplate(template: ProductCoasTemplateResponse) {
    this.currentTemplate = template;

    this.inputs.template.class = "fa-circle-check";
    this.inputs.template.verified = true;
    this.inputs.template.data = template;
    this.inputs.template.value = template.name;

    if (template.product) {
      this.currentProduct = template.product;

      this.inputs.product.class = "fa-circle-check";
      this.inputs.product.verified = true;
      this.inputs.product.data = template.product;
      this.inputs.product.value = `${template.product.code} - ${template.product.name}`;
    }
  }

  createProductParameterByTemplate() {
    if (!this.currentProvider || !this.currentTemplate) {
      this.toastrService.warning("Debes seleccionar un proveedor y una plantilla");
      return;
    }

    const data = {
      providerId: this.currentProvider.id,
      coasParameterTemplateId: this.currentTemplate.id
    };

    this.loadingTemplate = true;

    this.coasParameterService.createProductParameterByTemplate(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Parámetros asignados por plantilla correctamente", "Éxito");
        this.getProductParameters(this.filterWord);
        this.cleanTemplateForm();
        this.loadingTemplate = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error?.message || "Error al aplicar la plantilla");
        this.loadingTemplate = false;
      }
    });
  }

  cleanTemplateForm() {
    this.currentTemplate = null;
    this.usingTemplate = false;

    this.inputs.template.value = null;
    this.inputs.template.verified = false;
    this.inputs.template.class = "fa-list";
    this.inputs.template.data = { id: null };
  }

  get verifyForm() {
    if (this.currentProvider == null || this.currentProduct == null || !this.inputs.parameter.verified) {
      return false;
    }
    return true;
  }
}
